// import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { getAllUniversities, addUniversity } from '../api/university';

export const GET_UNIVERSITIES = 'GET_UNIVERSITIES';
export const ADD_UNIVERSITY = 'ADD_UNIVERSITY';

function getUniversities (universities, error=null) {
    return {
        type: GET_UNIVERSITIES,
        universities,
        error
    }
}

export function handleGetUniversities () {
    return async (dispatch, getState) => {
        // dispatch(showLoading())
        try {
            const result = await getAllUniversities(getState().authedUser.token);
            if(result){
                const universities = result.data.data;
                // dispatch(hideLoading())
                return dispatch(getUniversities(universities));
            }  else {
                // dispatch(hideLoading())
                return dispatch(getUniversities(null, "Unknown error"));
            }
        } catch (error) {
            // dispatch(hideLoading())
            return dispatch(getUniversities(null, error));
        }
    }
}

function addNewUniversity (university, error=null) {
    return {
        type: ADD_UNIVERSITY,
        university,
        error
    }
}

export function handleAddNewUniversity (university) {
    return async (dispatch, getState) => {
        // dispatch(showLoading())
        try {
            const result = await addUniversity(university, getState().authedUser.token);
            if(result){
                const uni = result.data.data;
                // dispatch(hideLoading())
                console.log(result)
                return dispatch(addNewUniversity(uni));
            }  else {
                // dispatch(hideLoading())
                return dispatch(addNewUniversity(null, "Unknown error"));
            }
        } catch (error) {
            // dispatch(hideLoading())
            return dispatch(addNewUniversity(null, error));
        }
    }
}
